import React from 'react'
import { css } from '@emotion/react'

// components
import InputField from '~/components/finalForms/atoms/InputField'
import {InputAdornment} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";

export const ItemNameField = React.memo(() => {
  return(
      <div>
        <div>
          <InputField
              id="itemName"
              name="itemName"
              placeholder="商品名で調べる"
              startAdornment={
                <InputAdornment position="end">
                  <SearchIcon />
                </InputAdornment>
              }
          />
        </div>
      </div>
  )
})

ItemNameField.displayName = 'ItemNameField'
